export default {
    rolesList: {},
    roleFields: [
        {
            key: 'title',
            label: 'Role Title',
            sortable: true,
        },
        {
            key: 'associatedUsers',
            label: 'Associate Users',
            class: 'text-center',
            sortable: true,
        },
        {
            key: 'status',
            label: 'Status',
            class: 'text-center status-absolute-pos',
            sortable: true,
        },
        {
            key: 'action',
            label: 'Action',
            tdClass: 'user-roles-action',
        },
    ],

    permissions: {
        insights: [
            { text: 'View Alerts', value: 'view-alerts' },
            { text: 'Show Notification Bar', value: 'notification-bar' },
            {
                text: 'View Customer Verification Tracker',
                value: 'view-customer-tracker',
            },
            {
                text: 'View Activity Dashboard',
                value: 'view-activity-dashboard',
            },
            {
                text: 'View Customer Statistics',
                value: 'view-customer-statistics',
            },
            {
                text: 'Export Activity Dashboard',
                value: 'export-activity-dashboard',
            },
            {
                text: 'Export Customer Statistics',
                value: 'export-customer-statistics',
            },
        ],
        customerProfiles: [
            {
                text: 'View Customer Profile',
                value: 'view-customer-profile',
            },
            { text: 'Register Customer', value: 'register-customer' },
            {
                text: 'View Company Profile',
                value: 'view-company-profile',
            },
            { text: 'Register Company', value: 'register-company' },
            { text: 'Bulk Onboarding', value: 'bulk-upload' },
            { text: 'View Deeplink', value: 'view-deeplink-sent' },
            { text: 'Edit Profiles', value: 'edit-profile' },
            {
                text: 'KYC Status Investigation & Review',
                value: 'kyc-status-review',
            },
            {
                text: 'Manually Overwrite Verification Status',
                value: 'manually-overwrite',
            },
            { text: 'Open Alert Against Customers', value: 'open-alerts' },
            { text: 'Export Customers', value: 'export-customer-profile' },
            {
                text: 'Export Activity Timeline',
                value: 'export-activity-timeline',
            },
            {
                text: 'View Customer Verification',
                value: 'view-customer-verification',
            },
            {
                text: 'Manage Customer Verification',
                value: 'manage-customer-verification',
            },
            {
                text: 'Archive Customer Profiles',
                value: 'archive-customer-profile',
            },
        ],

        configurations: [
            { text: 'Labeling', value: 'labeling' },
            { text: 'View Notifications', value: 'view-notifications' },
            { text: 'Manage Notifications', value: 'manage-notifications' },
            { text: 'Upload Delta Only', value: 'upload-delta-list' },
            { text: 'Manage Idenfo Engine', value: 'idenfo-engine' },
            {
                text: 'Manage Screening Data',
                value: 'view-screening-data',
            },
            { text: 'Manage Form Builder', value: 'form-builder' },
            {
                text: 'Initiate Simulation Process',
                value: 'initiate-simulation-process',
            },
            { text: 'Manage Branding', value: 'branding' },
            { text: 'Access Configurations', value: 'configurations' },
            {
                text: 'Manage On-boarding Configurations',
                value: 'onboarding-configurations',
            },
            {
                text: 'Manage IDV Configurations',
                value: 'idv-configurations',
            },
            { text: 'Manage Screening List', value: 'screening-list' },
            { text: 'Manage Packages', value: 'manage-packages' },
            { text: 'Access Developer Tools', value: 'developer-tools' },
            { text: 'Manage Webhooks', value: 'manage-webhooks' },
            { text: 'Manage API Logs', value: 'manage-api-logs' },
            {
                text: 'Manage Application Access',
                value: 'manage-application-access',
            },
            { text: 'Package Subscription', value: 'subscribe-package' },
        ],

        systemUser: [
            { text: 'View System Users', value: 'view-users' },
            { text: 'Manage System Users', value: 'manage-users' },
            { text: 'View Roles & Permission', value: 'view-roles' },
            { text: 'Manage Roles & Permission', value: 'manage-roles' },
            { text: 'View Data Segments', value: 'view-data-segments' },
            { text: 'Manage Data Segments', value: 'manage-data-segments' },
            { text: 'Manage Team Members', value: 'manage-team-members' },
            { text: 'View Team Members', value: 'view-team-members' },
            // {
            //     text: 'View Application Access',
            //     value: 'view-application-access',
            // },
            // {
            //     text: 'Manage Application Access',
            //     value: 'manage-application-access',
            // },
        ],

        systemLogs: [{ text: 'View System Logs', value: 'system-logs' }],
        statusReview: [
            { text: 'Maker', value: 'maker' },
            {
                text: 'Checker',
                value: 'checker',
            },
            {
                text: 'Approver',
                value: 'approver',
            },
            {
                text: 'Unlock Alerts',
                value: 'unlock-alerts',
            },
        ],
    },
}
